"use client";
import { Animated } from "../animated";
import { AboutUs } from "../legacy/about-us";
import { SectionSeparator } from "../shared";
import { CaseStudiesGrid } from "./case-studies-grid";
import { ContactUs } from "./contact-us";
import { CaseStudiesHero } from "./hero";

export const CaseStudiesPage = () => {
  return (
    <Animated>
      <CaseStudiesHero />
      <CaseStudiesGrid />
      <SectionSeparator
        imageUrl="/images/separator-4.webp"
        overlayClassName="from-black/20 to-black/30"
      />
      <AboutUs />
      <ContactUs />
    </Animated>
  );
};
